/** A due date with its standing beside it: the date, then a danger chip "33 days overdue" when it has
 * passed, else the quiet "in 8 days" (U3). Colour is never the only signal: the chip carries an icon
 * and the words. A filing with no countdown (a regime that is not law yet, or no date) is the date
 * alone, or the words the caller gives for having none. */

import { StatusChip } from "../components/ui/StatusChip";
import { shortDate } from "../lib/format";
import { dueStatus } from "./dueStatus";
import styles from "./DueNote.module.css";

export function DueNote({
  date,
  days,
  none = "–",
  testId,
}: {
  /** The server's ISO due date, or null where it has none. */
  date: string | null | undefined;
  /** Days to the date (negative once passed); `undefined` for a date that is not counted down to. */
  days: number | null | undefined;
  /** What to print when there is no date. */
  none?: string;
  testId?: string;
}) {
  if (!date) return <span className={styles.none}>{none}</span>;
  const status = dueStatus(days);
  return (
    <span className={styles.note} data-testid={testId} data-due={status.kind}>
      <span>{shortDate(date)}</span>
      {status.overdue ? (
        <StatusChip tone="crit" size="sm">
          {status.overdue}
        </StatusChip>
      ) : status.ahead ? (
        <span className={styles.ahead}>{status.ahead}</span>
      ) : null}
    </span>
  );
}
